<ion-header>
  <ion-toolbar>
    <ion-title i18n="@@employeeShift.pageTitle"> Робоча зміна </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"> </ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="pt-4 pb-2">
    <div *ngIf="lastSession">
      <div class="card" style="position: relative">
        <span
          *ngIf="!lastSession.end"
          class="badge badge-success"
          style="
            position: absolute;
            font-size: 16px;
            font-weight: 500;
            top: -10px;
            left: 30px;
          "
          i18n="@@employeeShift.stateOpen"
        >
          Відкрита</span
        >
        <span
          *ngIf="lastSession.end"
          class="badge badge-secondary"
          style="
            position: absolute;
            font-size: 16px;
            font-weight: 500;
            top: -10px;
            left: 30px;
          "
          i18n="@@employeeShift.stateClosed"
        >
          Закрита</span
        >
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="h4">
                {{ employeeName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="row">
                <div class="col-sm-6" i18n="@@employeeShift.dateStart">
                  Дата початку
                </div>
                <div class="col-sm-6">
                  {{
                    lastSession.start
                      ? (lastSession.start | date : 'dd.MM HH:mm')
                      : ''
                  }}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" i18n="@@employeeShift.dateClose">
                  Дата закриття
                </div>
                <div class="col-sm-6">
                  {{
                    lastSession.end
                      ? (lastSession.end | date : 'dd.MM HH:mm')
                      : ''
                  }}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" i18n="@@employeeShift.durationLabel">
                  Тривалість
                </div>
                <div class="col-sm-6" i18n="@@employeeShift.durationHours">
                  {{ duration }} год
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-4" *ngIf="!lastSession.end">
                <ion-button
                  class="w-100"
                  color="success"
                  (click)="selectSession(lastSession)"
                  i18n="@@employeeShift.continue"
                >
                  Продовжити
                </ion-button>
              </div>
              <div *ngIf="!lastSession.end">
                <ion-button
                  class="w-100"
                  (click)="closeSession()"
                  i18n="@@employeeShift.closeShift"
                >
                  Закрити зміну
                </ion-button>
              </div>
              <div *ngIf="lastSession.end" class="mb-4">
                <ion-button
                  class="w-100"
                  (click)="openSession()"
                  i18n="@@employeeShift.openShift"
                >
                  Відкрити зміну
                </ion-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer *ngIf="isNewSessions">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="solid"
        color="success"
        (click)="startSession()"
        style="font-size: 22px; line-height: 50px"
        i18n="@@employeeShift.startShift"
      >
        Почати зміну
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<style>
  ::ng-deep .terminal-session-modal {
    --height: 390px;
  }
</style>
